// Docker/OCI image-index API client (roadmap item 137 Phase B).
//
// Consumes the read-only `GET /api/v1/repos/{id}/docker/images` endpoint
// added in Phase A (`api/internal/handlers/repo_docker_images.go`), which
// aggregates `docker_tags`/`docker_manifests` per `image_path` so the
// Repo Detail Contents tab can render a human-readable "image → tags"
// view instead of the raw `manifests/<image>/sha256:<digest>` mirror
// path.

import useSWR from 'swr';

export interface DockerImageTag {
  tag: string;
  digest: string;
  media_type: string;
  size_bytes: number;
  updated_at: string;
}

export interface DockerImage {
  image_path: string;
  tags: DockerImageTag[];
}

export interface DockerImagesResponse {
  images: DockerImage[];
}

const fetcher = (url: string) =>
  fetch(url, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  }).then((r) => {
    if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
    return r.json();
  });

export function useDockerImages(repoID: string | undefined) {
  return useSWR<DockerImagesResponse>(
    repoID ? `/api/v1/repos/${repoID}/docker/images` : null,
    fetcher,
  );
}
